module.exports = __webpack_public_path__ + "img/horizontal_6_2_6005.c80a0157.png";